<div class="coworker-profile-container">
  <div class="header">
    <div class="logout" (click)="goBack()">
      <img [src]="arrowLeftIcon" />
    </div>
    <h3 class="title">
      {{ "coworker.profile.my-profile-title" | translate }}
    </h3>
  </div>
  <div class="form" [formGroup]="coworkerInfoForm" *ngIf="coworkerInfo">
    <div class="form-section">
      <cowing-input
        [inputStyle]="EInputStyleType.Secondary"
        [isForm]="true"
        [placeholder]="'coworker.edit-profile.name' | translate"
        [label]="'coworker.edit-profile.name' | translate"
        [control]="coworkerInfoForm.get('name')"
      >
      </cowing-input>
    </div>
    <div class="form-section">
      <cowing-input
        [inputStyle]="EInputStyleType.Secondary"
        [isForm]="true"
        [placeholder]="'coworker.edit-profile.cp' | translate"
        [label]="'coworker.edit-profile.cp' | translate"
        [control]="coworkerInfoForm.get('cp')"
      >
      </cowing-input>
    </div>
    <div class="form-section">
      <cowing-input
        [inputStyle]="EInputStyleType.Secondary"
        [isForm]="true"
        [placeholder]="'coworker.edit-profile.email' | translate"
        [label]="'coworker.edit-profile.email' | translate"
        [control]="coworkerInfoForm.get('email')"
      >
      </cowing-input>
    </div>
    <div class="form-section">
      <cowing-input
        [inputStyle]="EInputStyleType.Secondary"
        [isForm]="true"
        [placeholder]="'coworker.edit-profile.id_employee' | translate"
        [label]="'coworker.edit-profile.id_employee' | translate"
        [control]="coworkerInfoForm.get('employee_id')"
      >
      </cowing-input>
    </div>
    <div class="form-section dropdown">
      <cowing-input-dropdown
        [inputStyle]="EInputStyleType.Secondary"
        [isForm]="true"
        [label]="'coworker.edit-profile.language' | translate"
        [control]="coworkerInfoForm.get('language')"
        [options]="[
          { name: 'coworking.general.spanish_lang' | translate, id: 'es_ES' },
          { name: 'coworking.general.english_lang' | translate, id: 'en_EN' }
        ]"
        [type]="'object'"
      >
      </cowing-input-dropdown>

      <!-- <cowing-input
        [inputStyle]="EInputStyleType.Secondary"
        [isForm]="true"
        [placeholder]="'coworker.edit-profile.language' | translate"
        [label]="'coworker.edit-profile.language' | translate"
        [control]="coworkerInfoForm.get('language')"
      >
      </cowing-input> -->
    </div>
    <div class="form-section">
      <cowing-input
        [inputStyle]="EInputStyleType.Secondary"
        [isForm]="true"
        [placeholder]="'coworker.edit-profile.current_cowings' | translate"
        [label]="'coworker.edit-profile.current_cowings' | translate"
        [control]="coworkerInfoForm.get('current_cowings')"
      >
      </cowing-input>
    </div>
    <div class="form-section">
      <cowing-input
        [inputStyle]="EInputStyleType.Secondary"
        [isForm]="true"
        [placeholder]="'coworker.edit-profile.total_cowings' | translate"
        [label]="'coworker.edit-profile.total_cowings' | translate"
        [control]="coworkerInfoForm.get('total_cowings')"
      >
      </cowing-input>
    </div>
  </div>
  <div class="footer">
    <cowing-button
      [disabled]="coworkerInfoForm.disabled"
      [label]="'Guardar'"
      [type]="EButtonType.Rounded"
      [iconShow]="false"
      (event)="editCoworker()"
    >
    </cowing-button>
  </div>
  <!-- <div class="tabs">
    <cowing-tabs [active]="EActiveTab.Profile"></cowing-tabs>
  </div> -->
</div>
